import request, {requestJson} from '../main';
const service = ""
class NoticeApi {
    private url: string = service + "/notice";

    // 添加或者编辑
    public addOrUpdate(args: any){
        return request({
            url: this.url + '/add-or-update',
            method: 'post',
            data: args
        })
    }

    // 详情接口
    public getDetail(args: any){
        return request({
            url: this.url + '/get-detail',
            method: 'get',
            params: args
        })
    }

    public delete(args: any){
        return request({
            url: this.url + '/delete',
            method: 'post',
            data: args
        })
    }

    public pageList(args: any){
        return request({
            url: this.url + '/page-list',
            method: 'get',
            params: args
        });
    }
}
const noticeApi = new NoticeApi();
export {noticeApi}
